import { IModalState } from './Modal-types';

const modalState: IModalState = {
    state: {
        modals: {
            leaveGame: {
                show: false,
                data: null,
            },
            leaveAllGames: {
                show: false,
                data: null,
            },
            deleteAccount: {
                show: false,
                data: null,
            },
            rules: {
                show: false,
                data: null,
            },
            timeout: {
                show: false,
                data: null,
            },
            share: {
                show: false,
                data: null,
            },
            actionsLog: {
                show: false,
                data: null,
            },
            blockUser: {
                show: false,
                data: null,
            },
			termsAndConditions: {
				show: false,
				data: null,
			},
        },
    },
    mutations: {
        openModal(state, { type, show, data = null }: { type: string, show: boolean, data: any }) {
            state.modals[type] = {
                show,
                data,
            };
        },
        closeModal(state, type: string) {
            state.modals[type] = {
                show: false,
                data: null,
            };
        },
    },
    actions: {
        async openModal({ commit }, options: { type: string, data: any }) {
            commit('openModal', { ...options, show: true });
        },
        async closeModal({ commit }, type: string) {
            commit('closeModal', type);
        },
    },
    getters: {
        leaveGameData: state => state.modals.leaveGame.data,
        leaveAllGamesData: state => state.modals.leaveAllGames.data,
    },
};

export default modalState;
